import Bloks from './Bloks'

const MapBloks = ({ items, ...props }) => items && items.map((item) => <Bloks blok={item} key={item._uid} {...props} />)

export default MapBloks
